import {
  GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_DARK,
  GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT,
  SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_DARK,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_SPACE_FIXED_300,
} from '@oneaudi/unified-web-common';
import type { CustomTheme } from '../../@types/theme';
import { ThemeType } from './types';

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

const spacings = {
  fixed: SYS_SPACE_FIXED_300,
  pageMargin: `var(--page-margin)`,
};

const colorsDark = {
  background: GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  invertedBackground: GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  text: SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_DARK,
  invertedText: GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT,
};

const colorsLight = {
  background: GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  invertedBackground: GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  text: GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_LIGHT,
  invertedText: GLOBAL_COLOR_TYPOGRAPHY_COPY_DEFAULT_DARK,
};

export const darkTheme: CustomTheme = {
  name: ThemeType.dark,
  colors: colorsDark,
  breakpoints,
  spacing: spacings,
};

export const lightTheme: CustomTheme = {
  name: ThemeType.light,
  colors: colorsLight,
  breakpoints,
  spacing: spacings,
};

export { CustomTheme };
